import React from 'react';
import { useMediaQuery } from 'react-responsive';
import bali from "../Assets/PopularDestination/bali.jpg";
import abudhabi from "../Assets/PopularDestination/abudhabi.jpg";
import gulmarg from "../Assets/PopularDestination/gulmarg.jpg";
import allepey from "../Assets/PopularDestination/allepey.jpg";
import istanbul from "../Assets/PopularDestination/istanbul.jpg";
import lakshwadeep from "../Assets/PopularDestination/lakshwadeep.jpg";
import Carousel from './Carousel';

const PopularDestinations = () => {
  const isMobile = useMediaQuery({ maxWidth: 1024 }); // maxWidth for mobile and tablet screens

  return (
    <div className="container mx-auto px-5 py-2 lg:px-32 lg:pt-16">
      <h3 className="mb-2 mt-0 text-3xl font-medium leading-tight text-gray-700 text-center text-primary p-6">
        Popular Destinations to visit this Month
      </h3>
      {isMobile ? (
        <Carousel />
      ) : (
        <div className="-m-1 flex flex-wrap md:-m-2 rounded-xl">
          <div className="flex w-1/2 flex-wrap">
            <div className="relative w-1/2 p-1 md:p-2 rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30">
              <a href="/form" className="block relative overflow-hidden rounded-lg">
                <img
                  alt="gallery"
                  className="block h-full w-full rounded-lg object-cover object-center"
                  src={bali}
                />
              </a>
              <div className='ml-2 mt-2'>
                <p className="text-lg font-semibold text-gray-800">Bali, <span className="text-sm text-gray-600 font-normal">Indonesia</span></p>
                <div className="flex mt-1 space-x-2">
                  <span className="bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-red-400 border border-red-400 rounded-xl">Beaches</span>
                  <span className="bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-red-400 border border-red-400 rounded-xl">Temples</span>
                </div>
              </div>
            </div>
            <div className="relative w-1/2 p-1 md:p-2 rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30">
              <a href="/form" className="block relative overflow-hidden rounded-lg">
                <img
                  alt="gallery"
                  className="block h-full w-full rounded-lg object-cover object-center"
                  src={abudhabi}
                />
              </a>
              <div className='ml-2 mt-2'>
                <p className="text-lg font-semibold text-gray-800">Abu Dhabi, <span className="text-sm text-gray-600 font-normal">UAE</span></p>
                <div className="flex mt-1 space-x-2">
                  <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300 rounded-xl">Adventure Sports</span>
                  <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300 rounded-xl">Skyscrapers</span>
                </div>
              </div>
            </div>
            <div className="w-full p-1 md:p-2 rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30">
              <a href="/form" className="block relative overflow-hidden rounded-lg">
                <img
                  alt="gallery"
                  className="block h-full w-full rounded-lg object-cover object-center"
                  src={lakshwadeep}
                />
              </a>
              <div className='ml-2 mt-2'>
                <p className="text-lg font-semibold text-gray-800">Lakshwadeep, <span className="text-sm text-gray-600 font-normal">India</span></p>
                <div className="flex mt-1 space-x-2">
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400 rounded-xl">Island Beaches</span>
                  <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-blue-400 border border-blue-400 rounded-xl">Coral Reefs</span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-1/2 flex-wrap">
            <div className="w-full p-1 md:p-2 rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30">
              <a href="/form" className="block relative overflow-hidden rounded-lg">
                <img
                  alt="gallery"
                  className="block h-full w-full rounded-lg object-cover object-center"
                  src={gulmarg}
                />
              </a>
              <div className='ml-2 mt-2'>
                <p className="text-lg font-semibold text-gray-800">Gulmarg, <span className="text-sm text-gray-600 font-normal">India</span></p>
                <div className="flex mt-1 space-x-2">
                  <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500 rounded-xl">Snow Sports</span>
                  <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500 rounded-xl">Scenic Beauty</span>
                </div>
              </div>
            </div>
            <div className="relative w-1/2 p-1 md:p-2 rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30">
              <a href="/form" className="block relative overflow-hidden rounded-lg">
                <img
                  alt="gallery"
                  className="block h-full w-full rounded-lg object-cover object-center"
                  src={allepey}
                />
              </a>
              <div className='ml-2 mt-2'>
                <p className="text-lg font-semibold text-gray-800">Alleppey, <span className="text-sm text-gray-600 font-normal">India</span></p>
                <div className="flex mt-1 space-x-2">
                  <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400 rounded-xl">Backwaters</span>
                  <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-green-400 border border-green-400 rounded-xl">Houseboats</span>
                </div>
              </div>
            </div>
            <div className="relative w-1/2 p-1 md:p-2 rounded-lg shadow-none transition-shadow duration-300 ease-in-out hover:shadow-lg hover:shadow-black/30">
              <a href="/form" className="block relative overflow-hidden rounded-lg">
                <img
                  alt="gallery"
                  className="block h-full w-full rounded-lg object-cover object-center"
                  src={istanbul}
                />
              </a>
              <div className='ml-2 mt-2'>
                <p className="text-lg font-semibold text-gray-800">Istanbul, <span className="text-sm text-gray-600 font-normal">Turkey</span></p>
                <div className="flex mt-1 space-x-2">
                  <span className="bg-purple-100 text-purple-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-purple-400 border border-purple-400 rounded-xl">Historic Sites</span>
                  <span className="bg-purple-100 text-purple-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-purple-400 border border-purple-400 rounded-xl">Bazaars</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PopularDestinations;
